import React, { SyntheticEvent } from "react";
import { NavLink } from "react-router-dom";
import { Dropdown, DropdownItemProps, Icon, Menu } from "semantic-ui-react";

import UserRole from "../../data/enums/UserRole";
import IUser from "../../data/user/User";
import { ReactComponent as AppLogo } from "../../static/favicon.svg";

interface ITopNavbarMobileProps {
    language: string;
    allLanguagesConfig: DropdownItemProps[] | undefined;
    handleLanguageChange: (_: SyntheticEvent<HTMLElement, Event>, { value }: any) => void;
    handleLogout: () => void;
    user: IUser | undefined;
    currentURL: string;
}

const TopNavbarMobile: React.FC<ITopNavbarMobileProps> = (props: ITopNavbarMobileProps) => {
    const { language, allLanguagesConfig, handleLanguageChange, handleLogout, user, currentURL } = props;

    return (
        <Menu borderless color="grey" compact fixed="top" fluid inverted={false} style={{ paddingLeft: "-3px", paddingRight: "-3px" }}>
            <Menu.Item header style={{ paddingBottom: "0px", paddingTop: "0px" }}>
                <AppLogo style={{ height: "28px", width: "28px" }} />
            </Menu.Item>
            <Menu.Item as={NavLink} exact to="/">
                <Icon color="violet" exact name="home" />
            </Menu.Item>
            {user && (
                <>
                    <Menu.Item
                        as={Dropdown}
                        className={currentURL.includes("/search") ? "selected" : ""}
                        simple
                        trigger={<Icon color="violet" name="search" />}
                    >
                        <Dropdown.Menu>
                            <Dropdown.Item as={NavLink} to="/priests/search">
                                <Icon color="violet" name="user" />
                            </Dropdown.Item>
                            <Dropdown.Item as={NavLink} to="/parishes/search">
                                <Icon color="violet" name="users" />
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Menu.Item>

                    <Menu.Item as={NavLink} to="/charts">
                        <Icon color="violet" name="pie graph" />
                    </Menu.Item>

                    {[UserRole.OWNER, UserRole.ADMIN, UserRole.EDITOR].includes(user.role) && (
                        <Menu.Item
                            as={Dropdown}
                            className={currentURL.includes("/create") ? "selected" : ""}
                            simple
                            trigger={<Icon color="violet" name="add" />}
                        >
                            <Dropdown.Menu>
                                <Dropdown.Item as={NavLink} to="/priests/create">
                                    <Icon color="violet" name="add user" />
                                </Dropdown.Item>
                                <Dropdown.Item as={NavLink} to="/parishes/create">
                                    <Icon color="violet" name="users" />
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Menu.Item>
                    )}

                    {[UserRole.OWNER, UserRole.ADMIN, UserRole.EDITOR].includes(user.role) && (
                        <Menu.Item as={NavLink} to="/suggestions/search">
                            <Icon color="violet" name="lightbulb" />
                        </Menu.Item>
                    )}

                    {[UserRole.OWNER, UserRole.ADMIN].includes(user.role) && (
                        <Menu.Item as={NavLink} to="/administration">
                            <Icon color="violet" name="user secret" />
                        </Menu.Item>
                    )}
                </>
            )}

            {!user ? (
                <>
                    <Menu.Item as={NavLink} position="right" to="/login">
                        <Icon color="violet" name="sign in" />
                    </Menu.Item>

                    <Menu.Item as={NavLink} to="/register">
                        <Icon color="violet" name="signup" />
                    </Menu.Item>
                </>
            ) : (
                <Menu.Item onClick={handleLogout} position="right">
                    <Icon color="violet" name="log out" />
                </Menu.Item>
            )}

            <Menu.Item>
                <Dropdown onChange={handleLanguageChange} options={allLanguagesConfig} value={language} />
            </Menu.Item>
        </Menu>
    );
};

export default TopNavbarMobile;
